// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar archivos de traducción
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';

// Configuración de recursos
const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  // Detecta el idioma del navegador
  .use(LanguageDetector)
  // Pasa la instancia de i18n a react-i18next.
  .use(initReactI18next)
  // Inicializa i18next
  .init({
    resources,
    fallbackLng: 'es', // Idioma por defecto si la detección falla o el idioma no existe
    debug: process.env.NODE_ENV === 'development', // Muestra logs en desarrollo

    interpolation: {
      escapeValue: false, // React ya escapa los valores, no es necesario para él
    },

    detection: {
      // Orden y métodos de detección de idioma
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'], // Dónde guardar el idioma detectado/seleccionado
    }
  });

export default i18n;